import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    constructor(props) {
        super(props);
        this.id = `dfp-${props.name}-${Math.floor(Math.random() * Math.floor(100))}`;
    }

    componentDidMount() {
        this.props.register({
            name: this.props.name,
            id: this.id,
        });
    }

    shouldComponentUpdate() {
        return false;
    }

    render({ name, class: className }) {
        return (
            <dfp name={name} className={className}>
                <div id={this.id} />
            </dfp>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    register: (payload) => dispatch({ type: 'dfp:register', payload: payload }),
});

export default connect(null, mapDispatchToProps)(Component);
